import React from "react";
import { Link } from "react-router-dom";
const Warranty = () => {
  return (
  <div>
      {/* Spinner Start */}
     
      {/* Spinner End */}
  

  
      <div class="container container1">
        <h1 class="title">RIGID VINL <span class="highlight">Warranty</span></h1>
        <p class="description">
        This warranty provided by Leapatinternational is applied only to the original purchaser and is non-transferable.
        </p>

        <div class="note">
            <strong>Note:</strong> 
           <p> Leapatinternational guarantees that the RIGID VINL is visually flawless throughout the warranty period. Before installation, customers or installers must thoroughly examine each plank. This warranty does not extend to any visible defects post-installation. </p>
           <p>Leapatinternational retains the authority to confirm defects through technical analysis or inspection of samples. If manufacturing defects are identified, Leapatinternational will replace the aected materials. Otherwise, Leapatinternational reserves the right to dismiss claims under this warranty. </p>
        </div>

        <h2 class="section-title">What Is Covered <span class="highlight">Under Warranty?</span></h2>

        <h3>Manufacturing Defects</h3>
        <p>Leapatinternational assures that the flooring remains free from delamination and is devoid of manufacturing flaws, dimensions, thickness, and plank stability, in accordance with ASTM F3261.</p>

        <h3>Wear And Tear Warranty</h3>
        <p>Leapatinternational guarantees that during the specified timeframe in the provided table, the wear layer will not experience wear that penetrates through it. Scratches, indentations, or loss of gloss are not classified as wear. Wear-through is described as damage resulting from light to moderate foot traic that does not extend to the pattern layer of the product. </p>

        <table>
            <thead>
                <tr>
                    <th>Protective Thickness</th>
                    <th>0.5 MM</th>
                    <th>0.3 MM</th>
                    <th>0.2 MM</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>Residential</td>
                    <td>20 Years</td>
                    <td>10 Years</td>
                    <td>5 Years</td>
                </tr>
                <tr>
                    <td>Commercial</td>
                    <td>7 Years</td>
                    <td>5 Years</td>
                    <td>3 Years</td>
                </tr>
            </tbody>
        </table>

        <h3>Waterproof</h3>
        <p>Vinyl planks boast water resistance, ensuring they remain unaected and maintain their structural integrity when exposed to typical household spills like water, wine, or mild cleansers without harsh chemicals.</p>

        <h6>What defines waterproofing?</h6>
        <p>Vinyl planks are completely impervious to water. It's essential to promptly clean up household spills to prevent the development of mold and mildew.</p>


        <h3>Installation</h3>
        <p>The planks must undergo proper installation following Leapatinternational's guidelines available at (WEBSITE).</p>

        <h4>Here are some essential notes :</h4>

       
        <ul class="checklist">
    <li>
        Maintain humidity levels between 30% to 55%, temperatures between 15°C to 30°C, pH levels between 7 to 9, and ensure the subfloor's flatness is under 4.8mm (3/16") within a 3m (9.86ft) span.
    </li>
    <li>
        Allow a 12mm (15/32") gap along walls and fixed objects to accommodate expansion in warmer temperatures. Ensure no grout residue remains along the walls.
    </li>
    <li>
        Avoid fixing the planks with nails or adhesive.
    </li>
    <li>
        Limit room length to no more than 10m (32.8ft).
    </li>
</ul>

<h2 class="section-title">What Is Not Covered <span class="highlight">Under Warranty?</span></h2>
<ul class="not-covered-list">
    <li>Any noticeable manufacturing defects post-installation, including discrepancies in dimensions, thickness, or colors.</li>
    <li>Damages resulting from accidents, fire, burns, or flooding.</li>
    <li>Indentations, scratches, or click joint damage caused by pets, high heels, golf shoes, rolling loads, wheelchairs, or furniture lacking proper floor protection.</li>
    <li>Scratches from moving heavy appliances without felt pads or plywood panels.</li>
    <li>Gradual loss of gloss or color over time or due to direct sunlight exposure.</li>
    <li>Damage from improper installation, such as untreated subfloors regarding flatness, firmness, moisture, and pH levels; inadequate flooring acclimation; use of non-recommended sealers or hammers; fixing planks with nails; or installing cabinets atop flooring.</li>
    <li>If the level of hydrostatic pressure is over 90% RH, or will be above 90% RH during the life of the slab, our warranty requires moisture mitigation, such as the use of a moisture barrier, like a 6-mil poly film.</li>
    <li>Installation over radiant floor heating with surface temperatures exceeding 85°F (29.8°C).</li>
    <li>Damage caused by additional underlayment for pre-attached flooring or unsuitable subfloors.</li>
    <li>Chips, warps, buckles, or cracks due to insufficient expansion spaces, unstable subfloors, improper flooring acclimation, or maintenance.</li>
    <li>Issues stemming from excessive moisture, mildew, alkaline substances, or hydrostatic pressure.</li>
    <li>Damage incurred from using unapproved floor care products or harsh chemicals.</li>
    <li>Flooring installation outdoors or in areas prone to frequent water exposure (e.g., swimming pools, bathrooms).</li>
    <li>Installation of vinyl planks with dimensions or thicknesses unsuitable for their intended use (e.g., core thicknesses of 3.5mm, 4mm, 4.5mm not recommended for public spaces like restaurants, schools, etc.). Vinyl flooring is not advisable for large areas or high-density usage such as hotel lobbies, hallways, sports stadiums, and school halls.</li>
</ul>


        <div class="contact">
            <p>To initiate a claim, please inform a representative with detailed descriptions of the issues, along with accompanying photos and videos.</p>
        </div>
    </div>
  
 
  <a href="#" className="btn btn-lg btn-primary btn-lg-square rounded-0 back-to-top">
      <i className="bi bi-arrow-up"></i>
    </a>


      {/* Optional: Add any other content or components here */}
  
      <style>
        {`
          /* Add your custom CSS here */
          .service-item-top {
            transition: transform 0.3s ease-in-out;
          }
  
          .service-item-top:hover {
            transform: scale(1.05);
          }
            .container1 {
    background: white;
  padding: 20px;
  margin: auto;
    margin-top: auto;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  margin-top: 135px;
  margin-bottom: 53px;
}

/* Title */
.title {
    font-size: 28px;
    
    margin-bottom: 10px;
}

.highlight {
    color: #17224D;
}

/* Description */
.description {
    font-size: 16px;
   
    margin-bottom: 20px;
}

/* Section Titles */
.section-title {
    font-size: 22px;
    margin-top: 30px;
    border-bottom: 2px solid #17224D;
    padding-bottom: 5px;
}

/* Note Box */
.note {
    
    padding: 10px;
    
    margin-bottom: 20px;
}

/* Warranty Table */
table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 20px;
}

th, td {
    border: 1px solid #ddd;
    padding: 10px;
    text-align: center;
}

th {
    background-color: #17224D;
    color: white;
}

/* List of Not Covered Items */
.not-covered {
    list-style: none;
    padding: 0;
}

.not-covered li {
    padding: 8px;
    background: #ffecec;
    margin: 5px 0;
    border-left: 4px solid #ff4d4d;
}

/* Contact Box */
.contact {
    background: #e0f2f1;
    padding: 15px;
    border-left: 4px solid #17224D;
    margin-top: 20px;
    text-align: center;
}
  
          /* Add any additional styling you want */
        `}
      </style>
    </div>
  );
};

export default Warranty;
